'use client';
import { UserType } from '@baseball-near-you/common';
import { Button } from '@baseball-near-you/ui';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import { useUpdateUserMutation } from '@bb/lib/mutations/useUpdateUserMutation';

export function RoleButton({
  role,
  onStepSuccess,
  label,
  type,
}: {
  type: UserType;
  role?: string;
  label?: string;
  onStepSuccess: () => Promise<void>;
}) {
  const { userProfile } = useUserProfile();
  const { updateUser, updatingUser, userError } = useUpdateUserMutation({
    showToast: false,
  });

  return (
    <Button
      key={role}
      className="mt-4 transition-all md:hover:scale-105"
      loading={updatingUser}
      variant={type === UserType.Personal ? 'default' : 'outline'}
      onClick={async () => {
        if (userProfile) {
          await updateUser({
            id: userProfile.id,
            role: role,
            type,
          });

          if (!userError) {
            await onStepSuccess();
          }
        }
      }}
    >
      {role ?? label}
    </Button>
  );
}
